<template>
  <div class="voting-trends-widget">
    <VotesChart v-if="hasData" class="votes-chart" :totals="totals" :is-loading="isLoading" :height="175" :chart-area="110"
                forced-time-interval="monthly" :allow-time-select="false"/>
  </div>
</template>

<script>
import VotesChart from '@/components/VotingTrends/VotesChart';
import dayjs from 'dayjs';
import {getVotingTrendsListsActivity} from '@/api/votingTrends';

export default {
  name: 'VotingTrendsWidget',
  props: {
    nodeId: {
      type: String
    }
  },
  components: {
    VotesChart
  },
  data() {
    return {
      voteParams: {
        startDate: dayjs().format('YYYY-MM-DD'),
        includes: 'chart',
        months: 24
      },
      hasData: true,
      isLoading: true,
      totals: []
    };
  },
  async created() {
    await this.getData();
    this.isLoading = false;
  },
  methods: {
    async getData() {
      this.voteParams.includes = 'chart';
      const {intervalData} = await getVotingTrendsListsActivity(this.nodeId, {...this.voteParams});
      if (!intervalData) {
        this.hasData = false;
        window.parent.postMessage(['noData'], '*');
        return;
      }
      this.totals = intervalData;
    }
  }
};
</script>

<style lang="postcss">
.voting-trends-widget {
  @apply relative overflow-hidden;

  .votes-chart {
    height: 175px;
  }
}
</style>